import {Attributes, Card} from 'platform/components';

import {useSelector} from 'react-redux';

import {FullState, FullVehicle} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {testIds, vehiclesRoutes} from '@dms/routes';
import {selectServiceBook, selectServiceBookStat} from '@dms/teas';

import {composePath, useNavigate} from 'shared/web';

type ModelSpecificationCardProps = {
  state: Partial<FullState>;
  vehicle?: Partial<FullVehicle>;
  canEditVehicle: boolean;
};

const ModelSpecificationCard = ({vehicle, state, canEditVehicle}: ModelSpecificationCardProps) => {
  const navigate = useNavigate();

  const serviceBookType = useSelector(selectServiceBook(state?.serviceBookType, vehicle?.type));
  const serviceBookState = useSelector(
    selectServiceBookStat(state?.serviceBookState, vehicle?.type)
  );

  const handleOnClick = () => {
    if (!vehicle?.id) {
      return;
    }

    return navigate(
      composePath(vehiclesRoutes.editV2Tab, {params: {id: vehicle.id, tab: 'vehicle-data'}})
    );
  };

  return (
    <Card
      title={i18n.t('entity.vehicle.labels.serviceBook')}
      actions={
        canEditVehicle
          ? [
              {
                variant: 'link',
                type: 'button',
                leftIcon: 'image/edit',
                onClick: handleOnClick,
                'data-testid': testIds.vehicles.vehicleData('serviceBook-edit'),
                title: i18n.t('general.actions.edit'),
              },
            ]
          : undefined
      }
      data-testid={testIds.vehicles.vehicleData('serviceBook')}
    >
      <Attributes
        data-testid={testIds.vehicles.vehicleData('serviceBook-parameters')}
        rows={[
          {
            label: i18n.t('general.labels.type'),
            value: serviceBookType?.label,
            testId: 'type',
          },
          {
            label: i18n.t('entity.vehicle.labels.serviceBookStateLabel'),
            value: serviceBookState?.label,
            testId: 'stateLabel',
          },
        ]}
      />
    </Card>
  );
};

export const ServiceBookCard = ModelSpecificationCard;
